import { useEffect, useState, useCallback } from "react";
import { getQueue, syncQueue } from "@/lib/offlineQueue";

export function useOffline() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [pending, setPending] = useState(getQueue().length);
  const [syncing, setSyncing] = useState(false);

  const refresh = useCallback(() => setPending(getQueue().length), []);

  const doSync = useCallback(async () => {
    if (!navigator.onLine || getQueue().length === 0) return { synced: 0 };
    setSyncing(true);
    const res = await syncQueue();
    setSyncing(false);
    refresh();
    return res;
  }, [refresh]);

  useEffect(() => {
    const goOnline = () => { setOnline(true); doSync(); };
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    window.addEventListener("lbm-queue-change", refresh);
    if (navigator.onLine) doSync();
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("lbm-queue-change", refresh);
    };
  }, [doSync, refresh]);

  return { online, pending, syncing, doSync };
}
